/*
 * This file is part of the nivo project.
 *
 * (c) 2016 Raphaël Benitte
 *
 * For the full copyright and license information, please view the LICENSE
 * file that was distributed with this source code.
 */
module.exports = {
    // local
    //nivoApiUrl: 'http://localhost:3030',
    //storybookUrl: 'http://localhost:6006/',

    // production
    nivoApiUrl: 'https://nivo-api.herokuapp.com',
    storybookUrl: 'http://nivo.rocks/storybook/',
}
